function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.45 19h9.1l3.075-9.225L12 4.45 4.375 9.775 7.45 19zM6 21L2 9l10-7 10 7-4 12H6z",
  fill: "#007892"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.707 6.793a1 1 0 010 1.414L16.395 9.52 14.98 8.105l1.313-1.312a1 1 0 011.414 0zm-3.937 5.352l-2.625 2.625-1.415-1.415 2.625-2.625 1.415 1.415zm-5.25 5.25l-1.313 1.312a1 1 0 01-1.414-1.414l1.312-1.313 1.415 1.415z"
})));